<template>
    <section>
        <div class=" flex justify-between mt-6">
            <div class="ml-10 lg:ml-1">
                <router-link to="/"><img class="lg:w-36" src="https://res.cloudinary.com/https-carrygo-com/image/upload/v1634105033/carrygoWebAssets/carrygo_logo_vrdtw8.svg" alt="logo"></router-link>
            </div>

            <div class=" mr-10 lg:mr-1">
               <router-link to="/contact"><button class=" bg-blue-700 text-white pr-6 pl-5 pt-2 pb-2 rounded-xl font-semibold lg:p-2 md:text-xs">Contact Us</button></router-link>
            </div>
        </div>
         <div>
            <ComingSoonModal 
            v-show="isModalVisible"
            @click="close"
        />
    </div>
    </section>
</template>

<script>
import ComingSoonModal from '../ComingSoonModal.vue';
export default {
    components:{ComingSoonModal},
    data() {
        return {
            isModalVisible: false
        }
    },
    methods: {
        close() {
            this.isModalVisible = false;
        },

        downloadApp() {
            this.isModalVisible = true;
        }
    }
}
</script>
